/**
 * /study-closed — shown when POST /interviews/initiate returns
 * 409 `study_closed` (the study's enrollment cap is reached, or its
 * status is no longer `published`). NEW page; no prototype equivalent.
 */
export function StudyClosed() {
  return (
    <div className="w-full max-w-[560px] mx-auto text-center">
      <h1 className="font-serif text-title-m text-surface-ink mb-3">
        This study is closed
      </h1>
      <p className="text-body-m text-surface-subtle">
        We've gathered enough responses for now. Thanks for being interested
        — keep an eye on your inbox for future opportunities.
      </p>
    </div>
  );
}
